module.exports = __webpack_public_path__ + "img/组 19.55e3c60c.png";